import React from 'react';
import { aboutImage, labImage } from '../../data/mock';
import { CheckCircle2 } from 'lucide-react';

const points = [
  'Laboratorio attrezzato di 100mq con strumentazione professionale',
  'Software gestionale dedicato per tracciare ogni riparazione',
  'Tecnici certificati e formazione continua sui nuovi prodotti',
  'Partnership consolidate con rivenditori e provider della zona',
];

export default function About() {
  return (
    <section id="chi-siamo" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img src={aboutImage} alt="Tecnico al lavoro" className="w-full h-[460px] object-cover" />
          </div>
          <div className="absolute -bottom-8 -right-4 lg:-right-10 w-44 h-44 lg:w-56 lg:h-56 rounded-2xl overflow-hidden border-8 border-white shadow-xl hidden sm:block">
            <img src={labImage} alt="Laboratorio" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -top-6 -left-6 bg-slate-900 text-white px-5 py-4 rounded-2xl shadow-xl">
            <div className="text-3xl font-extrabold leading-none">1996</div>
            <div className="text-xs uppercase tracking-widest text-sky-300 mt-1">Dal</div>
          </div>
        </div>

        <div>
          <div className="text-sky-600 text-xs font-bold uppercase tracking-[0.2em]">Chi siamo</div>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight leading-tight">Quasi 30 anni di esperienza al servizio della Brianza</h2>
          <p className="mt-5 text-slate-600 text-lg leading-relaxed">
            Siamo un centro assistenza nato nel 1996 nel cuore di Biassono. Una squadra di tecnici specializzati che si occupa di ritiro, diagnosi e riparazione di prodotti elettronici e informatici. Velocità, trasparenza e qualità del servizio sono i pilastri che ci hanno permesso di crescere costantemente.
          </p>

          <ul className="mt-8 space-y-3">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-sky-600 flex-shrink-0 mt-0.5" />
                <span className="text-slate-700">{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex gap-6 pt-6 border-t border-slate-200">
            <div>
              <div className="text-3xl font-extrabold text-slate-900">15mq</div>
              <div className="text-xs text-slate-500 uppercase tracking-wider mt-1">Reception</div>
            </div>
            <div>
              <div className="text-3xl font-extrabold text-slate-900">85mq</div>
              <div className="text-xs text-slate-500 uppercase tracking-wider mt-1">Laboratorio</div>
            </div>
            <div>
              <div className="text-3xl font-extrabold text-slate-900">15mq</div>
              <div className="text-xs text-slate-500 uppercase tracking-wider mt-1">Magazzino</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
